document.addEventListener('DOMContentLoaded', () => {
    // --- DATA ---
    // URL de base du CDN shopify communiquée:
    const SHOPIFY_CDN_URL = "https://cdn.shopify.com/s/files/1/0957/4527/8336/files/";

    const configData = {
        occasions: {
            'fiancailles': { name: 'Fiançailles' },
            'mariage': { name: 'Mariage' },
            'naissance': { name: 'Naissance / Anniversaire / Célébration' },
            'cadeau': { name: 'Cadeau' },
            'autre': { name: 'Autre' }
        },
        models: {
            'cocktail': { name: 'Cocktail à Syracuse', code1: '01', code2: 'COCKTAIL', quote: '« Un trait de Campari, un zeste d\'orange, un éclat de Syracuse. »' },
            'eterno': { name: 'Eterno', code1: '04', code2: 'VERDE', quote: '« Linstant devient promesse. »' },
            'halo': { name: "Halo d'Or", code1: '02', code2: 'HALODOR', quote: '« Une lueur dorée, une soirée chaude, un éclat d\'éternité. »' },
            'lacrime': { name: 'Lacrime Di Mari', code1: '03', code2: 'LACRIME', quote: '« Une invitation à voyager au coeur des mers lointaines, où l\'horizon rencontre l\'infini. »' }
        },
        stones: {
            'aigueMarine': { name: 'Aigue-marine', fileCode: 'AIGUE_MARINE' },
            'beryl': { name: 'Béryl vert', fileCode: 'BERYL' },
            'heliodore': { name: 'Héliodore', fileCode: 'HELIODORE' },
            'iolite': { name: 'Iolite', fileCode: 'IOLITE' },
            'grenat': { name: 'Grenat rouge', fileCode: 'GRENAT' },
            'tourmalineMiel': { name: 'Tourmaline miel', fileCode: 'TOURMALINE MIEL' },
            'tourmalineVerte': { name: 'Tourmaline verte', fileCode: 'TOURMALINE VERTE' },
            'diamantBlanc': { name: 'Diamant blanc', fileCode: 'DIAMANT BLANC' },
            'diamantCognac': { name: 'Diamant cognac', fileCode: 'DIAMANT BRUN' },
            'autrePierre': { name: "Une autre pierre", fileCode: 'CUSTOM' }
        },
        golds: {
            'jaune': { name: 'Or jaune', fileCode: 'C_OR JAUNE' },
            'rose': { name: 'Or rose', fileCode: 'B_OR ROSE' },
            'blanc': { name: 'Or blanc', fileCode: 'D_OR BLANC' },
            'bicolore': { name: 'Bicolore', fileCode: 'A_BICO' }
        },
        pricing: {
            'lacrime': {
                'iolite': '3 950',
                'aigueMarine': '4 150',
                'tourmalineVerte': '4 150',
                'tourmalineMiel': '4 100',
                'beryl': '4 050',
                'heliodore': '4 000',
                'grenat': '3 950'
            },
            'cocktail': {
                'iolite': '5 360',
                'aigueMarine': '5 860',
                'tourmalineVerte': '6 060',
                'tourmalineMiel': '5 910',
                'beryl': '5 610',
                'heliodore': '5 460',
                'grenat': '5 250'
            },
            'halo': {
                'iolite': '6 400',
                'aigueMarine': '6 600',
                'tourmalineVerte': '6 750',
                'tourmalineMiel': '6 420',
                'beryl': '6 600',
                'heliodore': '6 500',
                'grenat': '6 400'
            },
            'eterno': {
                'iolite': '3 800',
                'aigueMarine': '4 500',
                'tourmalineVerte': '3 980',
                'tourmalineMiel': '4 500',
                'beryl': '4 050',
                'heliodore': '3 850',
                'grenat': '3 650'
            }
        }
    };

    // --- STATE ---
    let currentStepIndex = 1;
    const totalSteps = 8;

    // Le panier de choix rempli par l'utilisateur
    let userChoices = {
        occasion: '',
        modele: '',
        pierre: '',
        autrePierre: '', // texte si propre pierre
        couleurOr: '',
        taille: '',
        tailleQuestion: '',
        personnalisation: '',
        personnalisationDetail: '',
        email: ''
    };

    // --- DOM ELEMENTS ---
    const steps = document.querySelectorAll('.step');
    const progressFill = document.getElementById('progress-fill');
    const selectTaille = document.getElementById('taille-bague');

    // Populate tailles (44 à 62)
    for (let i = 44; i <= 62; i++) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = i;
        selectTaille.appendChild(option);
    }

    // --- LISTENERS ---

    // Options cliquables (grilles)
    document.querySelectorAll('.options-grid, .grid-models, .grid-stones').forEach(grid => {
        const stepKey = grid.dataset.step;
        const options = grid.querySelectorAll('.option-btn, .option-card, .more-choice-btn, .stone-card');

        options.forEach(option => {
            option.addEventListener('click', (e) => {
                const el = e.currentTarget;
                const wasSelected = el.classList.contains('selected');

                // Remove selection from siblings
                options.forEach(opt => opt.classList.remove('selected'));

                // Toggle logic
                if (wasSelected && stepKey === 'pierre' && el.dataset.value === 'autrePierre') {
                    userChoices[stepKey] = ''; // On vide le choix
                    const customContainer = document.getElementById('custom-stone-container');
                    customContainer.classList.add('hidden');
                } else {
                    el.classList.add('selected');
                    userChoices[stepKey] = el.dataset.value;

                    // Particularités (Afficher custom inputs)
                    if (stepKey === 'pierre') {
                        const customContainer = document.getElementById('custom-stone-container');
                        if (userChoices.pierre === 'autrePierre') {
                            customContainer.classList.remove('hidden');
                        } else {
                            customContainer.classList.add('hidden');
                        }
                    }
                }
                if (stepKey === 'personnalisation') {
                    const customContainer = document.getElementById('custom-perso-container');
                    if (userChoices.personnalisation === 'oui') {
                        customContainer.classList.remove('hidden');
                    } else {
                        customContainer.classList.add('hidden');
                    }
                }
                if (stepKey === 'tailleQuestion') {
                    const selectContainer = document.getElementById('taille-select-container');
                    if (userChoices.tailleQuestion === 'oui') {
                        selectContainer.classList.remove('hidden');
                    } else {
                        selectContainer.classList.add('hidden');
                        userChoices.taille = 'Inconnue'; // On marque la taille comme inconnue
                    }
                }

                // Enable Next Button (même si on va scroller auto, c'est mieux pour l'état interne)
                checkStepValidity(currentStepIndex);

                // Auto-progression
                let shouldAutoProceed = true;

                // Exceptions :
                // 1) Si on vient de DÉsélectionner (le choix est vide), on ne bouge pas
                if (userChoices[stepKey] === '') {
                    shouldAutoProceed = false;
                }

                // 2) Règles métier spécifiques
                if (stepKey === 'pierre' && userChoices.pierre === 'autrePierre') {
                    shouldAutoProceed = false; // "Une autre pierre" nécessite de taper du texte, puis de cliquer
                }
                if (stepKey === 'personnalisation') {
                    if (userChoices.personnalisation === 'oui') {
                        shouldAutoProceed = false; // "Oui" nécessite de taper du texte
                    }
                    // Pour "Non" à l'étape personnalisation, ça va envoyer vers l'étape 7 (Résultat) automatiquement
                }
                if (stepKey === 'tailleQuestion') {
                    if (userChoices.tailleQuestion === 'oui') {
                        shouldAutoProceed = false; // "Oui" nécessite de choisir dans la liste déroulante juste après
                    }
                }

                if (shouldAutoProceed) {
                    // Lancer l'animation de clignotement sur l'élément cliqué (sauf pour les pierres pour garder le fond gris stable)
                    if (!el.classList.contains('stone-card')) {
                        el.classList.add('flash-animate');
                    }

                    // Léger délai pour laisser le temps à l'animation de se jouer ou juste delay pour UX (650ms)
                    setTimeout(() => {
                        goStep(currentStepIndex + 1);
                    }, 650);
                }

            });
        });
    });

    // Inputs particuliers qui doivent aussi valider la step
    selectTaille.addEventListener('change', (e) => {
        userChoices.taille = e.target.value;
        checkStepValidity(currentStepIndex);
        if (userChoices.taille) {
            // Flash animation pour le "oui" avant de passer à la suite
            const btnTaille = document.querySelector('[data-step="tailleQuestion"] .option-btn[data-value="oui"]');
            if (btnTaille) btnTaille.classList.add('flash-animate');

            setTimeout(() => {
                goStep(currentStepIndex + 1);
            }, 650);
        }
    });
    const cStoneEl = document.getElementById('custom-stone');
    if (cStoneEl) cStoneEl.addEventListener('input', (e) => {
        userChoices.autrePierre = e.target.value;
        checkStepValidity(currentStepIndex);
    });
    const cPersoEl = document.getElementById('custom-perso');
    if (cPersoEl) cPersoEl.addEventListener('input', (e) => {
        userChoices.personnalisationDetail = e.target.value;
        checkStepValidity(currentStepIndex);
    });
    const emailEl = document.getElementById('user-email');
    if (emailEl) emailEl.addEventListener('input', (e) => {
        userChoices.email = e.target.value;
        checkStepValidity(currentStepIndex);
    });

    // Gérer l'appui sur la touche "Enter" pour l'email
    if (emailEl) emailEl.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Empêcher un éventuel rechargement de page lié au formulaire natif
            const submitBtnEl = document.getElementById('submit-config');
            if (submitBtnEl) submitBtnEl.click();
        }
    });

    // Navigation Buttons
    document.querySelectorAll('.next-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            if (!checkStepValidity(currentStepIndex)) {
                showError(currentStepIndex);
                return;
            }

            let delay = 0;

            // Animation flash pour "Oui" à l'étape 6
            if (currentStepIndex === 6 && userChoices.personnalisation === 'oui') {
                const btnPerso = document.querySelector('[data-step="personnalisation"] .option-btn[data-value="oui"]');
                if (btnPerso) {
                    btnPerso.classList.add('flash-animate');
                    delay = 650;
                }
            }
            // Animation flash au cas où pour "Une autre pierre" à l'étape 3
            else if (currentStepIndex === 3 && userChoices.pierre === 'autrePierre') {
                const btnPierre = document.querySelector('[data-step="pierre"] .more-choice-btn[data-value="autrePierre"]');
                if (btnPierre) {
                    btnPierre.classList.add('flash-animate');
                    delay = 650;
                }
            }

            if (delay > 0) {
                setTimeout(() => {
                    goStep(currentStepIndex + 1);
                }, delay);
            } else {
                goStep(currentStepIndex + 1);
            }
        });
    });
    document.querySelectorAll('.back-btn-trigger').forEach(btn => {
        btn.addEventListener('click', () => goStep(currentStepIndex - 1));
    });

    // Valider ma création
    const submitBtnEl = document.getElementById('submit-config');
    if (submitBtnEl) submitBtnEl.addEventListener('click', async () => {
        if (!checkStepValidity(currentStepIndex)) {
            showError(currentStepIndex);
            return;
        }

        console.log("Submitting final data:", userChoices);

        // --- DÉBUT INTÉGRATION MAKE/ZAPIER ---
        // 1. URL du Webhook Make.com
        const WEBHOOK_URL = "https://hook.eu1.make.com/r1fht1k7jrij5f4plcrf5uv52bxi6oeg";

        try {
            // Change l'apparence du bouton pendant l'envoi pour faire patienter l'utilisateur
            const originalText = submitBtnEl.textContent;
            submitBtnEl.textContent = "ENVOI...";
            submitBtnEl.disabled = true;

            // 2. On prépare les données (nettoyage et traductions)
            let occasion = userChoices.occasion;
            let modele = userChoices.modele;
            let pierreChoisie = userChoices.pierre;
            let autrePierre = userChoices.autrePierre;
            let couleurOr = userChoices.couleurOr;
            let taille = userChoices.taille;
            let personnalisation = userChoices.personnalisation;
            let personnalisationDetail = userChoices.personnalisationDetail || 'Aucune';
            let email = userChoices.email;
            let imageUrl = '';

            let prix = "Sur-mesure";
            if (configData.pricing && configData.pricing[userChoices.modele]) {
                const p = configData.pricing[userChoices.modele][userChoices.pierre];
                if (p) {
                    prix = `${p},00 €`;
                }
            }

            if (personnalisation === 'non') {
                personnalisationDetail = 'Aucune';
                personnalisation = 'Non';
            } else if (personnalisation === 'oui') {
                personnalisation = 'Oui';
            }

            // On s'assure que autrePierre n'est pas vide pour éviter l'erreur de validation "Missing value" de Brevo via Make
            if (!autrePierre || autrePierre.trim() === '') {
                autrePierre = 'Aucune';
            }
            if (occasion && configData.occasions[occasion]) {
                occasion = configData.occasions[occasion].name;
            }
            if (modele && configData.models[modele]) {
                modele = configData.models[modele].name;
            }
            if (pierreChoisie && configData.stones[pierreChoisie]) {
                pierreChoisie = configData.stones[pierreChoisie].name;
            }
            if (couleurOr && configData.golds[couleurOr]) {
                couleurOr = configData.golds[couleurOr].name;
            }

            const resultImage = document.getElementById('result-image');
            if (resultImage) {
                imageUrl = resultImage.src;
            }

            // 3. Création du colis final DANS L'ORDRE EXACT demandé pour Make
            const payload = {
                occasion: occasion,
                modele: modele,
                pierreChoisie: pierreChoisie,
                autrePierre: autrePierre,
                couleurOr: couleurOr,
                taille: taille,
                personnalisation: personnalisation,
                personnalisationDetail: personnalisationDetail,
                email: email,
                prix: prix,
                imageUrl: imageUrl
            };

            await fetch(WEBHOOK_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            // 3. Une fois envoyé, on passe à l'étape 8 (Remerciements)
            submitBtnEl.textContent = originalText;
            submitBtnEl.disabled = false;
            goStep(8);

        } catch (error) {
            console.error("Erreur lors de l'envoi des données :", error);
            // Même s'il y a une erreur réseau, on l'envoie à l'étape 8 pour ne pas le bloquer
            submitBtnEl.disabled = false;
            goStep(8);
        }
        // --- FIN INTÉGRATION MAKE/ZAPIER ---

    });

    // --- NAVIGATION LOGIC ---
    function goStep(targetIndex) {
        if (targetIndex < 1 || targetIndex > totalSteps) return;

        // Setup Step 7 before showing it
        if (targetIndex === 7) {
            prepareResultPage();
            document.getElementById('ambiance-visual').classList.add('hidden');
            document.getElementById('result-visual').classList.remove('hidden');
        } else if (targetIndex < 7) {
            document.getElementById('ambiance-visual')?.classList.remove('hidden');
            document.getElementById('result-visual')?.classList.add('hidden');
        }

        // Fullscreen target layout for step 8
        const wrapper = document.querySelector('.configurator-wrapper');
        const leftPanel = document.querySelector('.left-panel');
        if (targetIndex === 8) {
            if (leftPanel) leftPanel.classList.add('hidden');
            if (wrapper) wrapper.classList.add('step-8-active');

            // On récupère la source de l'image de l'étape 7 pour l'afficher sur l'étape 8
            const resultImg = document.querySelector('#result-visual img');
            const thankYouImg = document.getElementById('thankyou-ring-img');
            if (resultImg && thankYouImg) {
                thankYouImg.src = resultImg.src;
            }
        } else {
            if (leftPanel) leftPanel.classList.remove('hidden');
            if (wrapper) wrapper.classList.remove('step-8-active');
        }

        const topNavBar = document.querySelector('.top-navbar');
        if (topNavBar) {
            if (targetIndex >= 7) {
                topNavBar.classList.add('dark-mode');
            } else {
                topNavBar.classList.remove('dark-mode');
            }
        }

        // Nettoyer les animations précédentes pour éviter qu'elles rejouent en faisant "Précédent"
        document.querySelectorAll('.flash-animate').forEach(el => el.classList.remove('flash-animate'));

        // Hide current
        steps[currentStepIndex - 1].classList.remove('active');
        // Show target
        steps[targetIndex - 1].classList.add('active');

        currentStepIndex = targetIndex;
        updateProgress();
        checkStepValidity(currentStepIndex);

        // Scroll Top Reset
        const stepsContainer = document.querySelector('.steps-container');
        if (stepsContainer) stepsContainer.scrollTop = 0;
        const configuratorWrapper = document.querySelector('.configurator-wrapper');
        if (configuratorWrapper) configuratorWrapper.scrollTop = 0;
        window.scrollTo(0, 0);
    }

    function updateProgress() {
        const percentage = ((currentStepIndex - 1) / (totalSteps - 1)) * 100;
        progressFill.style.width = percentage + '%';
    }

    function checkStepValidity(stepIndex) {
        let isValid = false;

        switch (stepIndex) {
            case 1: isValid = !!userChoices.occasion; break;
            case 2: isValid = !!userChoices.modele; break;
            case 3:
                if (userChoices.pierre === 'autrePierre') {
                    isValid = !!userChoices.autrePierre && userChoices.autrePierre.trim().length > 0;
                } else {
                    isValid = !!userChoices.pierre;
                }
                break;
            case 4: isValid = !!userChoices.couleurOr; break;
            case 5:
                if (userChoices.tailleQuestion === 'non') {
                    isValid = true;
                } else if (userChoices.tailleQuestion === 'oui' && userChoices.taille !== 'Inconnue' && userChoices.taille !== '') {
                    isValid = true;
                } else {
                    isValid = false;
                }
                break;
            case 6:
                if (userChoices.personnalisation === 'oui') {
                    isValid = !!userChoices.personnalisationDetail && userChoices.personnalisationDetail.trim().length >= 3;
                } else if (userChoices.personnalisation === 'non') {
                    isValid = true;
                } else {
                    isValid = false;
                }
                break;
            case 7:
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                isValid = emailRegex.test(userChoices.email);
                break;
            case 8: return true; // no validation
        }

        // Remove the error message if the user fixes the input
        if (isValid) {
            hideError(stepIndex);
        }

        return isValid;
    }

    function showError(stepIndex) {
        const currentStepEl = steps[stepIndex - 1];
        let errorMsg = currentStepEl.querySelector('.error-msg');
        if (!errorMsg) {
            errorMsg = document.createElement('p');
            errorMsg.className = 'error-msg';

            // Custom messages for specific steps
            if (stepIndex === 7) {
                errorMsg.textContent = 'Merci de saisir une adresse email valide';
            } else if (stepIndex === 3 && userChoices.pierre === 'autrePierre') {
                errorMsg.textContent = 'Veuillez décrire votre pierre';
            } else if (stepIndex === 6 && userChoices.personnalisation === 'oui') {
                errorMsg.textContent = 'Veuillez décrire votre personnalisation (3 lettres min).';
            } else {
                errorMsg.textContent = 'Veuillez faire un choix pour continuer.';
            }

            const actionsDiv = currentStepEl.querySelector('.actions');
            if (actionsDiv && actionsDiv.parentNode) {
                actionsDiv.parentNode.insertBefore(errorMsg, actionsDiv);
            } else {
                currentStepEl.appendChild(errorMsg);
            }
        }
    }

    function hideError(stepIndex) {
        const currentStepEl = steps[stepIndex - 1];
        const errorMsg = currentStepEl.querySelector('.error-msg');
        if (errorMsg) {
            errorMsg.remove();
        }
    }

    // --- IMAGE MAPPING LOGIC ---
    function prepareResultPage() {
        const dModel = configData.models[userChoices.modele];
        const dStone = configData.stones[userChoices.pierre];
        const dGold = configData.golds[userChoices.couleurOr];

        // Remplir le texte
        document.getElementById('result-model').textContent = dModel.name;
        document.getElementById('result-gold').textContent = dGold.name;
        if (userChoices.pierre === 'autrePierre') {
            document.getElementById('result-stone').textContent = "Pierre personnalisée";
        } else {
            document.getElementById('result-stone').textContent = dStone.name;
        }
        document.getElementById('result-quote').textContent = dModel.quote || '';

        let displayTailled = userChoices.tailleQuestion === 'non' ? 'À définir' : userChoices.taille;
        const sizeElem = document.getElementById('result-size');
        if (sizeElem) sizeElem.textContent = displayTailled;

        // --- Gérer le prix ---
        const priceElem = document.getElementById('result-price');
        const disclaimerElem = document.getElementById('price-disclaimer');
        const disclaimerCustomElem = document.getElementById('price-disclaimer-custom');
        let priceValue = null;
        if (configData.pricing && configData.pricing[userChoices.modele]) {
            priceValue = configData.pricing[userChoices.modele][userChoices.pierre];
        }

        if (priceValue) {
            priceElem.textContent = `${priceValue},00 €*`;
            priceElem.style.display = 'block';
            if (disclaimerElem) disclaimerElem.style.display = 'block';
            if (disclaimerCustomElem) disclaimerCustomElem.style.display = 'none';
        } else {
            priceElem.textContent = "Prix sur-mesure*";
            priceElem.style.display = 'block';
            if (disclaimerElem) disclaimerElem.style.display = 'none';
            if (disclaimerCustomElem) {
                if (userChoices.pierre === 'diamantBlanc' || userChoices.pierre === 'diamantCognac') {
                    disclaimerCustomElem.style.display = 'block';
                } else {
                    disclaimerCustomElem.style.display = 'none';
                }
            }
        }

        // Custom pierre message
        if (userChoices.pierre === 'autrePierre') {
            document.getElementById('custom-stone-msg').classList.remove('hidden');
        } else {
            document.getElementById('custom-stone-msg').classList.add('hidden');
        }

        // Calcul du filename PNG
        let fileLayerStone = (userChoices.pierre === 'autrePierre') ? "DIAMANT BLANC" : dStone.fileCode;
        let fileLayerGold = dGold.fileCode;

        // FORMAT GÉNÉRAL: MAISONPR_{code1}_{code2}_{gold}_{stone}.jpg
        let finalStoneSuffix = fileLayerStone.includes('.jpg') ? fileLayerStone : `${fileLayerStone}.jpg`;
        let imageFilename = `MAISONPR_${dModel.code1}_${dModel.code2}_${fileLayerGold}_${finalStoneSuffix}`;

        // IMPORTANT (Shopify URL Mapping) : 
        // 1. Remplacer tous les espaces par des underscores pour la requête CDN Shopify.
        // ex: MAISONPR_01_COCKTAIL_A_BICO_TOURMALINE VERTE.jpg -> MAISONPR_01_COCKTAIL_A_BICO_TOURMALINE_VERTE.jpg
        imageFilename = imageFilename.replace(/ /g, '_');

        // 2. Traitements des exceptions spécifiques demandées par le client
        let finalUrl = '';
        if (dModel.code2 === 'COCKTAIL' && dGold.fileCode === 'A_BICO' && dStone.fileCode === 'BERYL') {
            finalUrl = 'https://cdn.shopify.com/s/files/1/0957/4527/8336/files/MAISONPR_01_COCKTAIL_A_BICO_BERYL.jpg?v=1772439006';
        }

        if (!finalUrl) {
            finalUrl = SHOPIFY_CDN_URL + imageFilename;
        }
        console.log("Loading image : ", finalUrl, " (Original: " + imageFilename + ")");

        const loader = document.getElementById('image-loader');
        const resultImg = document.getElementById('result-image');

        loader.style.display = 'block';
        resultImg.style.display = 'none';

        const img = new Image();
        img.onload = function () {
            loader.style.display = 'none';
            resultImg.src = finalUrl;
            resultImg.style.display = 'block';
        };
        img.onerror = function () {
            console.error("L'image " + finalUrl + " n'a pas pu être chargée.");
            loader.style.display = 'none';
            resultImg.alt = "Image non trouvée pour cette combinaison. (" + imageFilename + ")";
            resultImg.style.display = 'block';
        };
        img.src = finalUrl;
    }

    // Init display
    steps.forEach(s => s.classList.remove('active'));
    steps[0].classList.add('active');
    updateProgress();
});
